/**
 * @file index.tsx
 *
 * @fileoverview Shows a gallery for the organization.
 */

import React, { useContext } from 'react';

import { OrganizationProfile } from '~/jobiqo/types/types';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { OrganizationGalleryWidgetEmpty } from '~/jobiqo/components/Organization/Widgets/Gallery/Empty';
import { OrganizationGalleryWidgetView } from '~/jobiqo/components/Organization/Widgets/Gallery/View';
import { isSectionHidden } from '~/jobiqo/utils/config';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
export const KEY = 'gallery';

export interface OrganizationGalleryWidgetProps {
  organization: OrganizationProfile;
}

export const OrganizationGalleryWidget = ({
  organization,
}: OrganizationGalleryWidgetProps) => {
  const { ORGANIZATIONS } = useFrontendConfig();
  const GROUP_FIELDS = ORGANIZATIONS.ORGANIZATION_PAGE_FIELDS[KEY];

  if (isSectionHidden(GROUP_FIELDS, organization.hiddenFields)) {
    return null;
  }

  const userContext: UserContextInterface = useContext(UserContext);

  if (!organization.gallery || organization.gallery?.length === 0) {
    return userContext.user && organization.canEdit ? (
      <OrganizationGalleryWidgetEmpty organization={organization} boxId={KEY} />
    ) : null;
  } else {
    return (
      <OrganizationGalleryWidgetView organization={organization} boxId={KEY} />
    );
  }
};
export default OrganizationGalleryWidget;
